import { useEffect, useRef, useState } from "react";
import useModalActions from "@hooks/common/useModalAction";
import CACReportModalContent, { CACValue } from "./CACReportModalContent";
import { useConfig } from "config/useConfig";
import BaseModalContent from "../BaseReportModalContent/BaseReportModalContetnt";
import { REPORT_MODAL_NAMES } from "config/labels";
import { ContextKey, SurfaceContext, useBufferPool } from "@features/analysis/rendering/Panels/Renderers/vtkManagers";
import { captureSurface3D, cropToSquare } from "utils/captureUtils";
import { useReportModal } from "@hooks/useReportModal";
import { usePanelContainer } from "@features/analysis/rendering/Panels/usePanelContainer";

const CACReportModal = ({ onClose }: { onClose: () => void }) => {
  const names = REPORT_MODAL_NAMES.cac;
  const { waitingAction, closeLoadingModal } = useModalActions();
  const { contextPool } = useBufferPool();
  const poolRef = useRef(contextPool);
  useEffect(() => { poolRef.current = contextPool; }, [contextPool]);

  const { analysisType } = usePanelContainer();

  async function capture3d(): Promise<string | undefined> {
    const d3context = {
      current: poolRef.current[`Surface3D` as ContextKey] as SurfaceContext,
    } as React.MutableRefObject<SurfaceContext | null>;
    if (!d3context?.current) return;
    let url = await captureSurface3D(d3context.current,analysisType);
    url = await cropToSquare(url!);
    return url;
  }

  const { config } = useConfig();
  const [imageSrc, setImageSrc] = useState<{ threeD?: string }>();

  const value: CACValue = {
    value: {
      lm:    { volume: config.agatstonScore[6], score: config.agatstonScore[1] },
      lad:   { volume: config.agatstonScore[7], score: config.agatstonScore[2] },
      lcx:   { volume: config.agatstonScore[8], score: config.agatstonScore[3] },
      rca:   { volume: config.agatstonScore[9], score: config.agatstonScore[4] },
      total: { volume: config.agatstonScore[5], score: config.agatstonScore[0] },
    },
  };

  useEffect(() => {
    let alive = true;
    (async () => {
      waitingAction({ message: "Waiting" });
      try {
        const url = await capture3d();
        if (alive) setImageSrc({ threeD: url });
      } finally {
        if (alive) closeLoadingModal();
      }
    })();
    return () => { alive = false; };
  }, []);

  return (
    <BaseModalContent
    className='cac'
    onClose={onClose} title={names.title}
    // vw={50} vh={65}
    >
      <CACReportModalContent imageSrc={imageSrc} value={value} />
    </BaseModalContent>
  );
};

export function useCACReportModal(res:{updateActivatedTool: (tool: any,check: boolean) => void}) {
  return useReportModal({Component:CACReportModal,...res});
}


